import { aiBgElements, state } from '../core/state.mjs';
import { CONFIG } from '../core/config.mjs';
import { detectFormats } from '../detection/detect-formats.mjs';
import { normalizeImageSrc, isPngImage } from '../utils/image-utils.mjs';
import { getCachedContainerWidth } from '../utils/cache.mjs';

/**
 * Transforme éléments ai-bg-src en backgrounds optimisés
 */
export async function backgroundTransform() {
    if (!aiBgElements.length) return;

    const formats = await detectFormats();
    const baseUrl = window.location.protocol + '//' + window.location.host;

    // Détermine format global
    let bestFormat = '';
    if (CONFIG.formats.preferredFormat === 'avif' && (!CONFIG.formats.autoDetect || formats.avif)) {
        bestFormat = 'avif';
    } else if (CONFIG.formats.preferredFormat === 'webp' && (!CONFIG.formats.autoDetect || formats.webp)) {
        bestFormat = 'webp';
    } else if (CONFIG.formats.preferredFormat === 'auto') {
        if (formats.avif) {
            bestFormat = 'avif';
        } else if (formats.webp) {
            bestFormat = 'webp';
        }
    }

    if (CONFIG.debug) {
        console.log(`[AI] ${aiBgElements.length} backgrounds, format: ${bestFormat || 'original'}`);
    }

    aiBgElements.forEach(el => {
        const src = el.getAttribute('ai-bg-src');
        if (!src) return;

        const normalizedSrc = normalizeImageSrc(src);
        const isPng = isPngImage(normalizedSrc);

        // Ajuste format pour PNG
        if (isPng && CONFIG.formats.pngToWebP && formats.webp) {
            bestFormat = 'webp';
            if (CONFIG.debug) {
                console.log(`[AI] Background PNG → WebP: ${normalizedSrc}`);
            }
        } else if (CONFIG.formats.preferredFormat === 'avif' && (!CONFIG.formats.autoDetect || formats.avif)) {
            bestFormat = 'avif';
        } else if (CONFIG.formats.preferredFormat === 'webp' && (!CONFIG.formats.autoDetect || formats.webp)) {
            bestFormat = 'webp';
        } else if (CONFIG.formats.preferredFormat === 'auto') {
            if (formats.avif && !(isPng && CONFIG.formats.pngToWebP)) {
                bestFormat = 'avif';
            } else if (formats.webp) {
                bestFormat = 'webp';
            }
        }

        if (CONFIG.debug) {
            console.log(`[AI] Background format: ${bestFormat || 'original'}`);
        }

        const containerWidth = getCachedContainerWidth(el);
        const formatParam = bestFormat ? `&format=${bestFormat}` : '';

        // Ajuste largeur selon pixel ratio (max 2x)
        const pixelRatio = window.devicePixelRatio || 1;
        const adjustedWidth = Math.floor(containerWidth * Math.min(pixelRatio, 2));

        const imageUrl = `${normalizedSrc}${formatParam}&width=${adjustedWidth}&org_if_sml=1`;

        const tempImg = new Image();

        tempImg.onload = function () {
            el.style.backgroundImage = `url("${imageUrl}")`;
            el.classList.add('ai-bg-loaded');
        };

        tempImg.onerror = function () {
            el.style.backgroundImage = `url("${baseUrl}${src}")`;
            el.classList.add('ai-bg-loaded');
            console.warn(`[AI] Erreur background: ${imageUrl}`);
        };

        tempImg.src = imageUrl;

        state.backgrounds.set(el, {
            src: normalizedSrc,
            width: containerWidth,
            format: bestFormat,
            initialWidth: containerWidth,
            useOriginal: false
        });

        el.removeAttribute('ai-bg-src');
    });
}
